// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UIkit from 'uikit/dist/js/uikit-core';
import initBioList from './theme/bioList';
import initFooterMenu from './theme/footerMenu';
import initGoBackButton from './theme/goBack';
import initHeaderMenu from './theme/headerMenu';
import initNewsFiltering from './theme/newsFiltering';
import initSlideshows from './theme/slideshow';
import initTimeline from './theme/timeline';
import initColumnBackgroundColor from './theme/columnBackgroundColor';
import initHeaderScroll from './theme/headerScroll';
import initRedirects from './theme/redirects';

initFooterMenu();
initHeaderMenu();
initGoBackButton();
initNewsFiltering();
initSlideshows();
initTimeline();
initBioList();
initColumnBackgroundColor();
initHeaderScroll();
initRedirects();
